(() => {
  const money = (pence) => `£${(pence / 100).toFixed(2)}`;

  const menu = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.nav');
  menu?.addEventListener('click', () => {
    const open = nav?.classList.toggle('open');
    menu.setAttribute('aria-expanded', String(Boolean(open)));
  });

  document.querySelectorAll('[data-size-guide-open]').forEach((button) => button.addEventListener('click', () => {
    const modal = document.querySelector('[data-size-guide]');
    if (modal) { modal.hidden = false; document.body.classList.add('modal-open'); }
  }));
  document.querySelectorAll('[data-size-guide-close]').forEach((button) => button.addEventListener('click', () => {
    const modal = document.querySelector('[data-size-guide]');
    if (modal) { modal.hidden = true; document.body.classList.remove('modal-open'); }
  }));

  const root = document.querySelector('[data-product-root]');
  if (!root) return;
  const variantsNode = document.querySelector('[data-product-json]');
  const variants = variantsNode ? JSON.parse(variantsNode.textContent || '[]') : [];
  const form = document.querySelector('#ProductForm');
  const idInput = form?.querySelector('[data-variant-id]');
  const addButton = form?.querySelector('[data-add-to-cart]');
  const price = root.querySelector('[data-product-price]');
  const mainImage = document.querySelector('#ProductMainImage');
  const stickyAdd = root.querySelector('[data-sticky-add]');
  const stickySelection = root.querySelector('[data-sticky-selection]');
  const message = form?.querySelector('[data-form-message]');

  const selections = () => Array.from(root.querySelectorAll('[data-option-position]')).map((fieldset) => fieldset.querySelector('[data-option-value].active')?.dataset.optionValue);
  const findVariant = () => variants.find((variant) => variant.options.every((option, index) => option === selections()[index]));
  const update = (clicked) => {
    const fieldset = clicked.closest('[data-option-position]');
    fieldset.querySelectorAll('[data-option-value]').forEach((button) => {
      const active = button === clicked;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    const label = fieldset.querySelector('[data-option-label]');
    if (label) label.textContent = clicked.dataset.optionValue;
    const variant = findVariant();
    if (clicked.dataset.fallbackImage && mainImage) mainImage.src = clicked.dataset.fallbackImage;
    if (!variant) {
      if (addButton) { addButton.disabled = true; addButton.textContent = 'Unavailable'; }
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (price) price.textContent = money(variant.price);
    if (variant.featured_image?.src && mainImage) mainImage.src = variant.featured_image.src;
    if (addButton) { addButton.disabled = !variant.available; addButton.textContent = variant.available ? `Add to bag — ${money(variant.price)}` : 'Sold out'; }
    if (stickyAdd) { stickyAdd.disabled = !variant.available; stickyAdd.textContent = variant.available ? `Add — ${money(variant.price)}` : 'Sold out'; }
    if (stickySelection) stickySelection.textContent = selections().filter(Boolean).join(' · ');
    history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  };
  root.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click', () => update(button)));

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (addButton) addButton.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Could not add this item.');
      const cart = await fetch('/cart.js').then((result) => result.json());
      document.querySelectorAll('[data-cart-count]').forEach((node) => node.textContent = cart.item_count);
      if (message) message.textContent = 'Added to your bag. Nice choice.';
    } catch (error) {
      if (message) message.textContent = error.message || 'Something went wrong.';
    } finally {
      const variant = findVariant();
      if (addButton) addButton.disabled = !variant?.available;
    }
  });
  stickyAdd?.addEventListener('click', () => form?.requestSubmit());
})();
